import { get, GetReturnType, post, put, remove } from "src/api/fetch";
import { getSchemaFromUrl } from "src/router/routes";

import { Type_Map } from "./types";

export const getMapById = (id: number): GetReturnType => {
    return get(`${VITE_API_URL}/${getSchemaFromUrl()}/maps/${id}`);
};

export const getAllMaps = (): GetReturnType => {
    return get(`${VITE_API_URL}/${getSchemaFromUrl()}/maps`);
};

export const createMap = (body: Partial<Type_Map>): GetReturnType => {
    return post(body, `${VITE_API_URL}/${getSchemaFromUrl()}/maps`);
};

export const updateMap = (
    mapId: number,
    body: Partial<Type_Map>,
): GetReturnType => {
    if (body === null) {
        throw new Error("Invalid argument: 'body' cannot be null");
    }
    return put(body, `${VITE_API_URL}/${getSchemaFromUrl()}/maps/${mapId}`);
};

export const deleteMap = (id: number): GetReturnType => {
    return remove(`${VITE_API_URL}/${getSchemaFromUrl()}/maps/${id}`);
};
